import { render } from "./MenuCrewItem.vue?vue&type=template&id=4c07f22f&scoped=true"
import script from "./MenuCrewItem.vue?vue&type=script&lang=js"
export * from "./MenuCrewItem.vue?vue&type=script&lang=js"

import "./MenuCrewItem.vue?vue&type=style&index=0&id=4c07f22f&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/space-tourism-website-main-VueJs/cli-version/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c07f22f"]])

export default __exports__